import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type QuoteRequestsV2ResponseDto = ClientInferResponseBody<
  typeof contract.quoteRequestsV2.findAll,
  200
>;

export type AllQuoteRequestsV2Dto = QuoteRequestsV2ResponseDto["data"][number];

export const fetchQuoteRequestsV2 = async (query: {
  page: number;
  perPage: number;
}): Promise<QuoteRequestsV2ResponseDto> => {
  const response = await api.quoteRequestsV2.findAll.query({
    query,
  });

  if (response.status === 200) {
    return response.body;
  }

  return {
    data: [],
    metadata: {
      page: query.page,
      perPage: query.perPage,
      allCount: 0,
      pageCount: 0,
    },
  };
};
